import { FC } from 'react'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined'
import { MainLayout } from 'views/layouts'
import { useTranslation } from 'react-i18next'
import {
  ModuleKpi,
  ModuleKpiAction,
  ModuleKpiContent,
  ModuleKpiGrid,
  ModuleKpiIcon,
  ModuleKpiLink,
  ModuleKpiTitle,
  ModulesPageHeader,
} from 'views/screens/Modules/styled'

const SkillsModules: FC = () => {
  const { t } = useTranslation()

  return (
    <MainLayout>
      <ModulesPageHeader>
        <h2>Configuración módulo {t('global.common.skillText')}</h2>
      </ModulesPageHeader>

      <ModuleKpiGrid>
        <ModuleKpiLink to="/modules/skills/questions">
          <ModuleKpi>
            <ModuleKpiIcon tone="pink">
              <HelpOutlineOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Preguntas</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/skills/actions">
          <ModuleKpi>
            <ModuleKpiIcon tone="violet">
              <AutoAwesomeOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Acciones de desarrollo</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/skills/texts">
          <ModuleKpi>
            <ModuleKpiIcon tone="blue">
              <TextSnippetOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Textos</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/skills/bank">
          <ModuleKpi>
            <ModuleKpiIcon tone="amber">
              <AccountTreeOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Banco de competencias</ModuleKpiTitle>
              <ModuleKpiAction>Abrir →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/skills/new">
          <ModuleKpi>
            <ModuleKpiIcon tone="green">
              <AddCircleOutlineOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Nueva competencia</ModuleKpiTitle>
              <ModuleKpiAction>Crear →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>
      </ModuleKpiGrid>
    </MainLayout>
  )
}

export default SkillsModules
